module.exports = __webpack_public_path__ + "src/assets/img/smoke_three.b3b53d46.svg";